import { ErrorEvent, Exception } from '@sentry/react'

export const isThirdPartyCodeBySentry = (event: ErrorEvent): boolean =>
  !!event.tags?.third_party_code

const markExceptionAsHandled = (exception: Exception): Exception => ({
  ...exception,
  mechanism: exception.mechanism ? { ...exception.mechanism, handled: true } : undefined,
})

export const markEventExceptionsAsHandled = (event: ErrorEvent): ErrorEvent => ({
  ...event,
  exception: {
    ...event.exception,
    values: event.exception?.values?.map(markExceptionAsHandled),
  },
})

export const tagEvent = (
  event: ErrorEvent,
  tags: Record<string, number | string | boolean>,
): ErrorEvent => ({ ...event, tags: { ...event.tags, ...tags } })
